// GENERATED — DO NOT HAND-EDIT.
//
// Source of truth: specs/tier-05-experience/role.entity-hint.yaml
// Generator: tools/v2-gen/v2gen.py
// Regenerate via: make v2-generate-screens
//
// Hand-edits to non-override-block content WILL be lost on next
// regeneration. See specs/_product/dashboard-v2-page-generator.md §5
// for override blocks (imports / helpers / header-actions).

import type { ListPageConfig } from "../../components/composition/ListPage";
import { rolesApi } from "../../api/roles";
import type { Role } from "../../api/types";
// override-block:imports BEGIN
// override-block:imports END

// override-block:helpers BEGIN
// override-block:helpers END

export const roleListConfig: ListPageConfig<Role> = {
  title: "Roles",
  subtitle: "System roles (platform-admin, org-admin, org-staff, donor) are built-in. Custom roles let you grant fine-grained permission bundles.",
  queryKey: ["roles", "list"] as const,
  queryFn: ({ page, pageSize, sortField, sortDirection, search }) =>
    rolesApi.listRoles({ page, pageSize, sortField, sortDirection, search }),
  defaultSort: { field: "priority", direction: "desc" },
  pageSize: 50,
  rowHref: "/roles/{id}",
  search: { enabled: true, placeholder: "Search by slug or display name…" },
  emptyState: {
    title: "Only system roles defined",
    subtitle: "Admin / Staff / Donor are built-in. Create a custom role for fine-grained access (e.g. finance-reviewer).",
  },
  headerActions: [
    // override-block:header-actions BEGIN
    // override-block:header-actions END
  ],
  columns: [
    // override-block:column-display-name BEGIN
    { field: "display_name", label: "Role", type: "text", sortable: true },
    // override-block:column-display-name END
    // override-block:column-is-system BEGIN
    { field: "is_system", label: "Type", type: "text" },
    // override-block:column-is-system END
    { field: "priority", label: "Priority", type: "number", sortable: true },
    { field: "permission_count", label: "Permissions", type: "number" },
    { field: "user_count", label: "Users", type: "number" },
  ],
};
